(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-inquiry"]) return;
  try {
    
  (function () {
    var params = new URLSearchParams(window.location.search);

    // tab 切换
    var tabs = document.querySelectorAll('.inquiry-tab');
    var panes = document.querySelectorAll('.inquiry-pane');
    function activate(paneKey) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.pane === paneKey); });
      panes.forEach(function (p) { p.hidden = p.dataset.pane !== paneKey; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.pane); });
    });

    // 带产品参数进入时默认切到 Detailed
    var hasProduct = params.get('product_name') || params.get('product_number') || params.get('product');
    activate(hasProduct ? 'detailed' : 'quick');

    // 预填 hidden 与 Detailed 字段
    function fill(id, key) {
      var el = document.getElementById(id);
      if (el && params.get(key)) el.value = params.get(key).trim();
    }
    fill('inquirySourcePage', 'source_page');
    fill('dtProductName', 'product_name');
    fill('dtProductRef', 'product_number');
    fill('dtCategory', 'product_category');
    fill('dtType', 'product_type');
    fill('dtMaterial', 'material');
    fill('dtIntendedUse', 'intendedUse');
    if (params.get('inquiry_type')) {
      document.getElementById('inquiryType').value = params.get('inquiry_type');
      // 若为 product_quote，将“How can we help?”默认选中 Product quote
      if (params.get('inquiry_type') === 'product_quote') {
        var sel = document.getElementById('dtPurpose');
        if (sel) sel.value = 'Product quote';
      }
    }
    // 完整产品引用串放入 Quick 的 Product / application，方便客户看到
    if (params.get('product')) fill('qkProduct', 'product');

    // 文件选择显示文件名（Shopify 原生表单不发送附件，仅记录文件名）
    document.querySelectorAll('.inquiry-file').forEach(function (input) {
      input.addEventListener('change', function () {
        var labelEl = document.getElementById(input.dataset.filesLabel);
        if (labelEl) {
          labelEl.textContent = input.files.length
            ? Array.from(input.files).map(function (f) { return f.name; }).join(', ')
            : 'No files selected';
        }
      });
    });

    // Message 字数统计 (0/20000)
    var msg = document.getElementById('dtMessage');
    var msgCount = document.querySelector('[data-count-for="dtMessage"]');
    if (msg && msgCount) {
      msg.addEventListener('input', function () {
        msgCount.textContent = msg.value.length + '/20000';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
